export default __webpack_public_path__ + "static/media/logo-iconic.961e55a0.svg";